import axios from 'axios';
import { API_URL } from 'config/settings';

const ORG_SESSION_KEY = 'Org_Session_Key';

function ssoOrigin() {
  if (!API_URL) {
    return '';
  }
  return new URL(API_URL).origin;
}

/** Same acceptance as the backend login_hint: plausible email, otherwise password login. */
export function isSsoEmail(value) {
  const hint = String(value ?? '').trim().toLowerCase();
  if (!hint || hint.length > 254 || hint.includes(' ') || hint.startsWith('@') || hint.endsWith('@')) {
    return false;
  }
  const at = hint.indexOf('@');
  if (at <= 0) {
    return false;
  }
  const domain = hint.slice(at + 1);
  return domain.includes('.');
}

export function discoverSso(identifier) {
  return axios.post(`${ssoOrigin()}/sso/discover/`, { identifier });
}

export function rememberSsoOrganization(idPublicOrg) {
  try {
    sessionStorage.setItem(ORG_SESSION_KEY, idPublicOrg);
  } catch {
    /* the callback fails closed when the id cannot be stored */
  }
}

export function consumeSsoOrganization() {
  try {
    const idPublicOrg = sessionStorage.getItem(ORG_SESSION_KEY);
    sessionStorage.removeItem(ORG_SESSION_KEY);
    return idPublicOrg || null;
  } catch {
    return null;
  }
}

export function redirectToSamlLogin(idPublicOrg, email) {
  rememberSsoOrganization(idPublicOrg);
  const params = new URLSearchParams({ login_hint: email });
  window.location.assign(`${ssoOrigin()}/sso/saml/${idPublicOrg}/login/?${params.toString()}`);
}

export function exchangeSso(idPublicOrg, code) {
  return axios.post(
    `${ssoOrigin()}/sso/saml/${idPublicOrg}/exchange/`,
    { code },
    { withCredentials: true },
  );
}
